// extracted by mini-css-extract-plugin
export var backButton = "style-module--backButton--35551";
export var contentWrapper = "style-module--contentWrapper--60c9b";
export var productName = "style-module--productName--9bcb4";
export var productTitle = "style-module--productTitle--40efb";
export var title = "style-module--title--c7b2b";